import { Component, ElementRef, EventEmitter, Inject, Injector, Input, OnInit, Output, PLATFORM_ID, ViewChild, ViewEncapsulation } from '@angular/core';
import { Module } from "../../model/ModuleModel";
import { TextBannerModel, TextBannerOptions } from "./text-banner.model";
import { MediaPictureService } from "../../services/media-picture.service";
import { isPlatformBrowser } from '@angular/common';
import { AbstractComponent } from '../abstract.component';
import { EvaButtonComponent } from '../eva-button/eva-button.component';

@Component({
  selector: 'text-banner',
  template: `
    <text *ngIf="hasText()" [data]="module" class="-eva-3-mb-xlg"></text>

    <optional-link 
        [link]="options.clickable_banner ? (module.data.button?.link || '') : ''"
        [target]="module.data.button?.target"
        [overrideClickHandler]="options.clickable_banner ? this.clickHandler : null">
      
      <div content class="text-banner-container {{'img-' + (options.image_position || 'LEFT')}}"
          [ngStyle]="{'background': module.data.background || 'var(--color-white)', 'border': options.border_styles, 'border-radius': options.border_radius}"
          [ngClass]="{'btn-fwidth': options.full_width_button, '-eva-3-shadow-line': module.data.border}">
        <div class="image-container" *ngIf="module.data?.picture"
             [ngClass]="'img-' + (options.image_position || 'LEFT') + (options.ignore_image_margin ? ' img-ignore-margin-' + options.ignore_image_margin : '')">
          <img class="text-banner-image" [ngStyle]="{'max-width': options.image_max_width ?? '100%', 'max-height': options.image_max_height ?? '100%'}"
            [src]="mediaService.getMediaUrl(module.data.picture?.src)" loading="lazy"
            [alt]="module.data.picture?.alt || module.data.picture?.alt_mobile"/>
        </div>

        <div class="non-image-container {{'btn-' + (options.button_position || 'RIGHT')}} {{options.compact_design ? 'compact' : ''}}">
          <div class="text-container">
            <div class="title-driver-container">
              <tag-text *ngIf="module.data.title?.text" class="title-content {{options.compact_design ? 'compact' : ''}}" [data]="module.data.title"></tag-text>
              <span *ngIf="module.data.driver?.text" class="eva-3-driver">
                <span class="driver-text" [innerHTML]="module.data.driver?.text"></span>
              </span>
            </div>
            <tag-text *ngIf="module.data.text?.text" class="text-content" [data]="module.data.text"></tag-text>
          </div>

          <eva-button #evaButton *ngIf="module.data.button" [options]="module.data.button"
                      [moduleId]="module.id" [uniqueId]="module.unique_id"
                      [moduleIndex]="module.row_number"
                      [ngClass]="'btn-' + (options.button_position || 'RIGHT') + (options.compact_design ? ' compact' : '')"
                      (clickEvent)="clickEvent.emit()">
          </eva-button>
        </div>
      </div>
    </optional-link>
  `,
  styleUrls: ['./text-banner.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TextBannerComponent extends AbstractComponent implements OnInit {
  private static MODULE_ID = 'TextBannerModule';
  private textProps: string[] = ['pretitle', 'title', 'subtitle'];
  useResponsiveStyle: boolean = true;

  options: TextBannerOptions;

  @Input() override module: Module<TextBannerModel>;
  @Output() clickEvent: EventEmitter<void> = new EventEmitter();
  @ViewChild('evaButton') evaButtonRef: EvaButtonComponent;

  constructor(injector: Injector, public mediaService: MediaPictureService, @Inject(PLATFORM_ID) private platformId: string) {
    super(injector);
   }

  ngOnInit(): void {
    const storageCondition = this.module?.data?.browser_storage_condition;
    if (storageCondition && isPlatformBrowser(this.platformId)) {
      const value = (storageCondition.storage_type == 'LOCAL' ? localStorage : sessionStorage)?.getItem(storageCondition.key);
      const showModule = storageCondition.value == value;
      if (!showModule && this.module.unique_id) {
        document.getElementById(this.module.unique_id)?.classList?.add("-hidden");
      }
    }
    this.options = this.module.data.options || {};
  }

  hasText(): boolean {
    return this.textProps.some(textProp => this.module && this.isNotEmpty(this.module[textProp]));
  }

  private isNotEmpty(obj): boolean {
    return Object.keys(obj ?? {}).length > 0;
  }

  clickHandler = () => {
    if (this.module.data?.button && this.evaButtonRef) {
      this.evaButtonRef?.clickHandler(new Event('click'));
    } else {
      this.clickEvent.emit();
    }
  }

  getModuleId(): string {
    return TextBannerComponent.MODULE_ID;
  }
}
